/**
 * Normalisation du métier pour l'instrumentation uniquement. Le serveur
 * applique la même normalisation pour sa clé de cache ; ici, elle sert
 * seulement à agréger les évènements sur une écriture stable.
 */
export function normalizeMetierPourEvenement(raw: string): string {
  return raw.toLowerCase().replace(/\s+/g, " ").trim();
}
